import React from 'react';
import { ContainerComponent, today, wrap } from 'AppReact';
import { DayText, WeekText } from './atoms';
import { CalendarHeaderWrapper, CalendarWrapper, FlexWrapWrapper } from './wrappers';
import { CalendarDate, MonthSelector } from './molecules';
import { LeftArrowSvg, RightArrowSvg, TrashBinSvg } from 'components/icons';
import Controller from './controller'
import { calendarDates, monthNames, weekdays } from './helpers';
import { isSameDay, subDays } from 'date-fns';
import internalState from './internalState';
import { ClickableIcon } from 'atoms';
import { FlexCenterJustifyEndWrapper, Mt3, Mx2, Ml3, FlexCenterWrapper } from 'wrappers';

export const definition = {
  name: 'Calendar',
  controller: Controller,
  initialProps: ({ selectedDate, selectedPeriod, disabledBefore, disabledAfter, hasRemove, borderless, borderRadius }) => {
    let month = selectedDate ? selectedDate.getMonth() : today().getMonth();
    let year = selectedDate ? selectedDate.getFullYear() : today().getFullYear();

    return {
      selectedDate,
      selectedPeriod,
      disabledBefore,
      disabledAfter,
      month,
      year,
      hasRemove,
      borderRadius,
      borderless
    }
  },
  props: internalState,
  elements: [
    {
      wrapper: CalendarWrapper,
      displayState: ({ borderless, borderRadius, }) => ({ borderless, borderRadius }),
      name: 'Calendar',
      elements: [
        {
          wrapper: CalendarHeaderWrapper,
          displayState: ({ borderless }) => ({ borderless }),
          name: 'CalendarHeader',
          elements: [
            {
              component: CalendarDate,
              name: 'CalendarDate',
              renderIf: ({ borderless }) => !borderless,
              bindings: ({ month, year }) => ({ month: monthNames[month], year: `${year}` })
            },
            {
              name: 'Selector',
              wrapper: FlexCenterWrapper,
              elements: [
                {
                  name: 'PrevYear',
                  component: MonthSelector,
                  bindings: ({ month, year }) => ({ month, year, icon: <LeftArrowSvg double width='12' heigth='18' /> }),
                },
                {
                  name: 'PrevMonth',
                  component: MonthSelector,
                  bindings: ({ month, year }) => ({ month, year, icon: <LeftArrowSvg width='12' heigth='18' /> })
                },
                {
                  component: wrap(CalendarDate, Ml3),
                  name: 'CalendarDate',
                  renderIf: ({ borderless }) => borderless,
                  bindings: ({ month, year }) => ({ month: monthNames[month], year: `${year}` })
                },
                {
                  name: 'NextMonth',
                  component: MonthSelector,
                  bindings: ({ month, year }) => ({ month, year, icon: <RightArrowSvg width='12' heigth='18' /> })
                },
                {
                  name: 'NextYear',
                  component: MonthSelector,
                  bindings: ({ month, year }) => ({ month, year, icon: <RightArrowSvg double width='12' heigth='18' /> })
                },
              ]
            },
          ]
        },
        {
          name: 'HeaderRow',
          wrapper: FlexCenterWrapper,
          elements: [
            {
              name: 'WeekDayName',
              component: WeekText,
              isListOf: weekdays,
              displayValue: ({ _listItem }) => _listItem,
            }
          ]
        },
        {
          name: 'Dates',
          wrapper: FlexWrapWrapper,
          elements: [
            {
              name: 'Day',
              component: DayText,
              isListOf: { date: ({ month, year }) => calendarDates(new Date(year, month)) },
              displayValue: ({ date, month }) => date.getMonth() === month ? date.getDate() : '',
              displayState: ({ date, selectedDate, selectedPeriod, disabledBefore, disabledAfter }) => {
                const selected = isSameDay(date, selectedDate)
                const inSelectedPeriod = selectedPeriod && (selectedPeriod[0] || selectedPeriod[1]) && selectedPeriod[0] <= date && date <= (selectedPeriod[1] ?? new Date(3000, 11, 31));
                const disabled = (disabledBefore && date < subDays(disabledBefore, 1)) || (disabledAfter && date > disabledAfter);
                let roundedLeft = selectedPeriod?.[0] && isSameDay(date, selectedPeriod[0]);
                let roundedRight = selectedPeriod?.[1] && isSameDay(date, selectedPeriod[1]);
                if (roundedLeft && roundedRight) {
                  roundedLeft = false;
                  roundedRight = false
                }
                return { selected, inSelectedPeriod: inSelectedPeriod, disabled, roundedLeft, roundedRight }
              },
              bindings: ({ date, disabledAfter, disabledBefore }) => ({ date, disabled: (disabledBefore && date < subDays(disabledBefore, 1)) || (disabledAfter && date > disabledAfter) })
            }
          ]
        },
        {
          component: wrap(wrap(wrap(ClickableIcon, FlexCenterJustifyEndWrapper), Mt3), Mx2),
          name: 'DeleteButton',
          bindings: ({ }) => ({}),
          renderIf: ({ hasRemove, selectedDate }) => hasRemove && selectedDate,
          displayValue: ({ }) => TrashBinSvg({ width: 18, height: 20 })
        }
      ]
    }
  ]
}

export default ContainerComponent(definition)